module.exports = __webpack_public_path__ + "static/media/22ESCWA10.a162f3ad.jpg";